import { AppState } from '@Redux/store';
import { Folder } from '@Models';

export const getFolders = (state: AppState, props: any): Array<Folder> => {
  return (
    state.folders.entity?.filter((item) => item.parentId === props.parentId) ??
    []
  );
};
